"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const initSliderSectionCarousel = () => {
    const sliderCarousels = $('.slider__carousel');
    if (sliderCarousels.length) {
        sliderCarousels.each(function () {
            const $thisSlider = $(this);
            const options = {
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 6500,
                autoplay: true,
                autoplaySpeed: 0,
                centerMode: true,
                cssEase: 'linear',
                variableWidth: true,
                infinite: true,
                initialSlide: 1,
                arrows: false,
                draggable: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            };
            $thisSlider.slick(options);
        });
    }
};
$(document).ready(() => {
    initSliderSectionCarousel();
});
